import { render } from "./Test.vue?vue&type=template&id=3e7d42b4&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import "./Test.vue?vue&type=style&index=0&id=3e7d42b4&scoped=true&lang=css"

import exportComponent from "D:\\케이터링\\html(JW 가상화서버)\\justinfood\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7d42b4"]])

export default __exports__